var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgShape1 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "78.8892617px",
    height: "199px",
    viewBox: "0 0 78.8892617 199",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path Copy 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Homepage_002",
    transform: "translate(-632.110738, -1248.000000)",
    fill: "#5B5EFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-30",
    transform: "translate(130.000000, 1058.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-Copy-9",
    transform: "translate(1.000000, 190.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M669.514682,157.019796 L669.514682,186.406583 C669.514682,196.097064 680.050761,202.139765 688.472777,197.290263 L753.700606,159.678925 C757.603491,157.428892 760,153.286787 760,148.795245 L760,104.842907 C760,100.359887 757.603491,96.2092594 753.700606,93.959227 L675.814076,49.0523293 C671.911191,46.8022968 669.514682,42.6601916 669.514682,38.1686496 L669.514682,-5.73255182 C669.514682,-10.215571 667.109615,-14.3661991 663.215288,-16.6162315 L585.354435,-61.5060835 C581.442991,-63.7646388 576.615738,-63.7646388 572.695734,-61.5060835 L507.407993,-23.8606542 C499.011653,-19.0196753 499.011653,-6.94279655 507.407993,-2.09329479 L572.721411,35.5691802 C576.624297,37.8192127 579.020805,41.9613179 579.020805,46.4528599 L579.020805,90.3540613 C579.020805,94.8370805 581.425873,98.9877086 585.320199,101.237741 L663.206729,146.144639 C667.109615,148.386148 669.514682,152.528254 669.514682,157.019796 Z",
    id: "Path-Copy-5",
    transform: "translate(630.555369, 67.900000) scale(-1, 1) translate(-630.555369, -67.900000) "
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgShape1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/shape_1.c80ce54a3329a527de01dfb0f5b373ad.svg";